// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"2b2ce5f6","977":"0efdce5a"}[chunkId] + ".chunk.js";
};